import { render, staticRenderFns } from "./growthModelManagement.vue?vue&type=template&id=1ef96cc4&scoped=true"
import script from "./growthModelManagement.vue?vue&type=script&lang=js"
export * from "./growthModelManagement.vue?vue&type=script&lang=js"
import style0 from "./growthModelManagement.vue?vue&type=style&index=0&id=1ef96cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef96cc4",
  null
  
)

export default component.exports